import { Injectable } from "@angular/core";
import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwMdFormActionState, DwModalButtonStandardConfigs, DwModalConfig, DwModalResult, DwModalService, DwModalSize } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import { AppMetaDataItemNames, PlanOfActionEntity } from "../../../meta-data/app-meta-data.service";
import { PoaPrintOptionsModalComponent } from "../components/poa-print-options-modal/poa-print-options-modal.component";
import { PoaPdfOptionsModalData, PoaPdfOptionsModalResult } from "../models/poa-pdf-options.model";
import { PlanOfActionPdfService } from "../services/plan-of-action-pdf.service";
import { PlanOfActionRepositoryService } from "../services/plan-of-action-repository.service";

@DwAction({
    keyName: 'poa-generate-pdf-action',
    display: 'Generate Plan Of Action PDF',
    actionType: DwActionType.formAction,
    isGlobal: false,
    parentItemName: [AppMetaDataItemNames.PlanOfAction],
    allowOnce: true,
    defaultButtonConfig: {
        useButtonDefaults: false,
        useParentDisplay: false,
        buttonText: 'Generate PDF',
        buttonClass: 'btn btn-secondary mr-1 mt-1',
        iconClass: 'fa fa-file-pdf-o'
    },
    configData: {
        requireValidation: false,
        redirectAfter: false,
        actionMessage: 'Generating PDF...',
    }
})
@Injectable()
export class POAGeneratePdfActionService implements DwActionHandler {

    constructor(
        private dwModalService: DwModalService,
        private planOfActionPdfService: PlanOfActionPdfService,
        private planOfActionRepositoryService: PlanOfActionRepositoryService
    ) { }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        const planOfAction = actionState.formApi.getFormData<PlanOfActionEntity>();

        return this.showOptions()
            .pipe(mergeMap(options => {
                if (!options) {
                    const result = new DwActionResult();
                    result.cancelled = true;

                    return of(result);
                }

                return this.planOfActionPdfService.downloadPlanOfActionPdf(planOfAction.PlanOfActionId, options.acsTestPortionIds)
                    .pipe(map(() => {
                        const result = new DwActionResult();
                        result.success = true;

                        return result;
                    }));
            }));
    }

    private showOptions(): Observable<PoaPdfOptionsModalResult> {
        return this.planOfActionRepositoryService.getAcsTestPortions()
            .pipe(mergeMap(acsTestPortions => {
                const modalConfig = new DwModalConfig<PoaPdfOptionsModalData>();

                modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
                modalConfig.allowFullScreen = false;
                modalConfig.modalSize = DwModalSize.medium;
                modalConfig.component = PoaPrintOptionsModalComponent;
                modalConfig.title = 'Generate Plan of Action PDF';
                modalConfig.data = {
                    acsTestPortions: acsTestPortions
                };

                return this.dwModalService.showModal<PoaPdfOptionsModalData, PoaPdfOptionsModalResult>(modalConfig)
                    .pipe(map((modalResult: DwModalResult<PoaPdfOptionsModalResult>) => {
                        if (modalResult.cancelled) {
                            return null;
                        }

                        return modalResult.data;
                    }));
            }));
    }
}
